module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result07-796ee80e81fdfae4efb1b3bfd27742d5.png";